<script setup>
import { useAppStore } from '@/stores/App'
import { useDisplay } from 'vuetify'

// mobile breakpoint
const { smAndDown } = useDisplay()

// Vars
const app = useAppStore()
const staticURLImg = useRuntimeConfig().public.staticURLImg
</script>

<template>
    <v-row id="theclients" class="my-16 justify-center slide-from-right">
        <!-- <v-col cols="10" class="text-h2 text-center font-weight-medium"> Our Clients </v-col> -->
        <v-col cols="11">
            <v-row class="justify-center">
                <v-col v-for="client in app.stClients" :key="client.alt" cols="6" sm="3" lg="2" class="text-center">
                    <v-avatar :size="smAndDown ? 64 : 128">
                        <v-img :src="staticURLImg + client.source" :alt="client.alt + `logo`"></v-img>
                    </v-avatar>
                    <div class="my-2 text-body-2 font-weight-medium text-grey">{{ client.alt }}</div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped>
.neg-margin {
    margin-bottom: -68px;
}
</style>
